import { Panel } from '@/ui/atoms/panel/Panel'
import { Typography } from '@/ui/atoms/typography/Typography'
import { useGsmMintForm, UseGsmMintFormResult } from '../../logic/useGsmMintForm'
import { MintForm } from './MintForm'
import { SuccessPanel } from './SuccessPanel'

export function GsmMintContainer({ simple }: { simple?: boolean }) {
  const mintData = useGsmMintForm()

  if (simple) {
    return <Form mintData={mintData} />
  }

  return (
    <Panel className="gap-4 p-4 md:p-8 sm:p-8">
      <Panel.Header>
        <div className="flex flex-col items-start gap-4">
          <Typography variant="h3" gradient className="text-xl">
            Mint USDXL
          </Typography>
          <Typography variant="prompt" className="font-medium text-base">
            Mint USDXL 1:1 with USDT0
          </Typography>
        </div>
      </Panel.Header>
      <Panel.Content className="mx-auto w-full max-w-xl">
        <Form mintData={mintData} />
      </Panel.Content>
    </Panel>
  )
}

const Form = ({ mintData }: { mintData: UseGsmMintFormResult }) => {
  return (
    <div>
      {mintData.pageStatus.state === 'success' && (
        <SuccessPanel fromAsset={mintData.fromAsset} toAsset={mintData.toAsset} resetForm={mintData.resetForm} />
      )}
      {mintData.pageStatus.state === 'form' && (
        <MintForm
          actionsEnabled={mintData.pageStatus.actionsEnabled}
          gsmMint={mintData.gsmMint}
          gsmMintState={mintData.gsmMintState}
          assetsToMintFields={mintData.assetsToMintFields}
          form={mintData.form}
          guestMode={mintData.guestMode}
          openConnectModal={mintData.openConnectModal}
        />
      )}
    </div>
  )
}
